import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { DeleteContactType } from '@/types/events/delete-contact';

export default function contactDelete(data: DeleteContactType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.deleteItemFromConversationsList(data);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.deleteActiveConversation(data);
  }
}
